import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchService } from '@ukam/core/services/search.service';
import { SearchResult } from '@ukam/core/searchs/search-result';
import { API_BASE_URL } from '@ukam/core/tokens/api-base-url.token';
import { StoredFile } from '@ukam/core/storages/models/stored-file';

@Injectable({ providedIn: 'root' })
export class StoredFileFinderSearchService extends SearchService<StoredFile> {

  constructor() {
    super({
      url: `${inject(API_BASE_URL)}/files/search`,
      limit: 100,
    });
  }

  override search(params?: any): Observable<SearchResult<StoredFile>> {
    this.params = { ...this.params, searchText: this.searchText(), currentOnly: true };
    return this._search();
  }
}
